import { render } from "./Disclaimer.vue?vue&type=template&id=44436b6a&scoped=true"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=44436b6a&scoped=true&lang=scss"
/* hot reload */
if (module.hot) {
  script.__hmrId = "44436b6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44436b6a', script)) {
    api.reload('44436b6a', script)
  }
  
  module.hot.accept("./Disclaimer.vue?vue&type=template&id=44436b6a&scoped=true", () => {
    api.rerender('44436b6a', render)
  })

}


import exportComponent from "/data/tfs-agent-build-2/agent/_work/2/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44436b6a"],['__file',"src/components/Disclaimer.vue"]])